import { VaroCategories } from 'shared/analytics/types/categories';
import { createBaseEventsMap } from 'shared/analytics/utils/createBaseEventsMap';

const EVENT_KEYS = {
  INCENTIVE_OPT_IN_SUBMITTED: 'Incentive Opt In Submitted',
  INCENTIVE_OPT_IN_COMPLETED: 'Incentive Opt In Completed',
  INCENTIVE_ERROR_ENCOUNTERED: 'Incentive Error Encountered',
};

export type VaroIncentiveEvents = (typeof EVENT_KEYS)[keyof typeof EVENT_KEYS];

const events = createBaseEventsMap<VaroIncentiveEvents>(
  EVENT_KEYS,
  VaroCategories.INCENTIVE,
);

export const {
  INCENTIVE_OPT_IN_SUBMITTED,
  INCENTIVE_OPT_IN_COMPLETED,
  INCENTIVE_ERROR_ENCOUNTERED,
} = events;
